import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { SocketService } from 'src/app/services/socket.service';
import { HostService } from 'src/app/services/host.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessagesComponent implements OnInit, OnDestroy {  

  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

  public selectedTab:number=1;
  
  notificationSubscription: Subscription

  public notifications: Array<any> = [];

  constructor(private notificationService:NotificationService, 
              private socketService: SocketService,
              public hostService: HostService,
              public router: Router) { }

  ngOnInit() {

    this.webSocket();

    this.getNotification();

  }

  private getNotification() {

    this.notificationSubscription = this.notificationService.fetchNotificationOfAdmin().subscribe((res: any) => {

      // console.log(res);

      this.notifications = res.notifications;

    })
  }

  private webSocket() {

    let pusher = this.socketService.initSocket();

    var channel = pusher.subscribe('channel-notification-admin');
    
    channel.bind('notification-admin', (response : any) => {
              
      if(response.notification) {

        if(response.notification.key != 'User') {

          this.notifications.push(response.notification);

        }

      }

      // console.log(response, this.notifications);

         
    });
    
  }

  navigation(notif: any) {

    switch (notif.key) {

      case 'Vehicle':

        this.router.navigate(["admin/vehicules/show-car"],{
          queryParams: { vehicule: notif.id },
        })

        break;
        
      case 'Litige':

        this.router.navigate(['admin/litiges']);

        break;

      case 'Sinistre': 

        this.router.navigate(["admin/details-sinistre"], {
          queryParams: { code: notif.id },
        }); 
        
        break;

      case 'Constat':

        this.router.navigate(["admin/voir-constat"], {
          queryParams: { code: notif.id },
        });

        break;

    }
    
  }

  openMessagesMenu() {
    this.trigger.openMenu();
    this.selectedTab = 0;
  }

  onMouseLeave(){
    this.trigger.closeMenu();
  }

  stopClickPropagate(event: any){
    event.stopPropagation();
    event.preventDefault();
  }

  ngOnDestroy(): void {
    
    this.notificationSubscription.unsubscribe();

  }

}
